import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import { Portuguese } from "flatpickr/dist/l10n/pt.js"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    maxDate: { type: String, default: "today" },
    minDate: { type: String, default: "" },
    minYear: { type: Number, default: 1920 },
    maxYear: { type: Number, default: 0 },
    allowFuture: { type: Boolean, default: false }
  }

  connect() {
    const config = {
      locale: Portuguese,
      dateFormat: "Y-m-d",
      altInput: true,
      altFormat: "d \\de F \\de Y",
      defaultDate: this.inputTarget.value || null,
      disableMobile: true,
      monthSelectorType: "dropdown",
      onReady: (selectedDates, dateStr, instance) => {
        this.addYearDropdown(instance)
      },
      onChange: (selectedDates, dateStr) => {
        this.inputTarget.value = dateStr
      }
    }

    // Configure maxDate
    if (this.allowFutureValue) {
      // No maxDate restriction for future dates
    } else if (this.maxDateValue) {
      config.maxDate = this.maxDateValue
    }

    // Configure minDate
    if (this.minDateValue) {
      config.minDate = this.minDateValue
    } else {
      config.minDate = new Date(this.minYearValue, 0, 1)
    }

    this.flatpickr = flatpickr(this.inputTarget, config)
  }

  addYearDropdown(instance) {
    const currentYear = new Date().getFullYear()
    const minYear = this.minYearValue
    const maxYear = this.allowFutureValue ? (this.maxYearValue || currentYear + 10) : currentYear
    const yearSelect = document.createElement("select")
    yearSelect.className = "flatpickr-monthDropdown-months"
    yearSelect.setAttribute("aria-label", "Ano")

    for (let year = maxYear; year >= minYear; year--) {
      const option = document.createElement("option")
      option.value = year
      option.textContent = year
      yearSelect.appendChild(option)
    }

    const selectedYear = instance.currentYear
    yearSelect.value = selectedYear

    yearSelect.addEventListener("change", (e) => {
      instance.changeYear(parseInt(e.target.value))
    })

    const monthNav = instance.calendarContainer.querySelector(".flatpickr-current-month")
    if (monthNav) {
      const existingYear = monthNav.querySelector(".numInputWrapper")
      if (existingYear) {
        existingYear.style.display = "none"
      }
      monthNav.appendChild(yearSelect)
      this.yearSelect = yearSelect
    }
  }

  disconnect() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
    }
  }
}
